import { Theme, ThemeOptions } from '@mui/material';
import { colors, colorsType } from './colors';
import { ChipVariant } from './types';
import { AppIcon } from '../components/app-icon/AppIcon';
import { CloseIcon } from '../assets/icons';

export const chipStyles = (theme: Theme): ThemeOptions => ({
  components: {
    // Chips
    MuiChip: {
      defaultProps: {
        deleteIcon: <AppIcon titleAccess="Remove" Icon={CloseIcon} />,
      },
      styleOverrides: {
        root: {
          cursor: 'inherit',
          height: 'auto',
          borderRadius: '5rem',
          paddingTop: '0.45rem',
          paddingBottom: '0.45rem',
        },
        label: {
          paddingLeft: '1.25rem',
          paddingRight: '1.25rem',
          fontWeight: theme.typography.fontWeightMedium,
        },
        deleteIcon: {
          marginRight: '0.75rem',
          fontSize: '0.875rem',
          color: 'inherit',
        },
      },
      variants: [
        {
          props: { variant: 'light' },
          style: {
            '&.MuiChip-light': {
              backgroundColor: colors.primary.light,
              color: colors.primary.main,
            },
          },
        },
        ...colorsType.map<ChipVariant>((color) => ({
          props: { variant: 'light', color },
          style: {
            '&.MuiChip-light': {
              backgroundColor: colors[color].light,
              color: colors[color].dark,
            },
          },
        })),
      ],
    },
  },
});
